<template lang="pug">

 app-card.document__card
   app-card-body.document__card-body
     app-card-caption.sended-text(v-if="html" v-html="text")
     app-card-caption.sended-text(v-else)
       pre {{text}}
     app-card-caption.mt-3 
       template(v-for="(p, index) in docResponse.docResponseParts")
         app-button-action.mr-2.mt-2(v-if="canSimpleView(p)" @click="viewResponse(p, false)") 
           v-icon(left dark) attach_file 
           | {{p.origFileName}}

         app-button-action.mr-2.mt-2(v-else-if="canEncView(p)" @click="viewResponse(p, true)") 
           v-icon(left dark) attach_file 
           | {{p.origFileName}}

         app-button-action.mr-2.mt-2(v-else-if="canSmimeEncView(p)" @click="viewResponse(p, true)") 
           v-icon(left dark) attach_file 
           | {{p.origFileName}}

         app-button-action.mr-2.mt-2(v-else-if="p.origFileName == 'mailheaders.txt'" @click="openFile(p)") Сведения.txt

         app-button-action.mr-2.mt-2(v-else-if="canViewSig(p) && attachedContentPart.length==1" @click="verifyResponse(p)") Проверить подпись
         app-button-action.mr-2.mt-2(v-else-if="canViewSig(p) && attachedContentPart.length>1" @click="selectToVerifyResponse(p)") Проверить подпись

   app-dialog(v-model="showSelect" header="Выберите подписанный файл" :width="'500px'")
       template(v-for="(p, index) in attachedContentPart")
         app-button-action.mb-2(@click="selectToVerify(p)") 
           v-icon(left dark) attach_file 
           | {{p.origFileName}}

</template>

<script>
import { docService } from '@/_services'
import { config } from '@/_helpers'

export default {
  props: {
    docResponse: null,
    sendChannel: null
  },
  data () {
    return {
      showSelect: false,
      selectedSig: null,
      text: "",
      html: true
    }
  },

  computed: {
    contentPart () {
      return this.docResponse.docResponseParts.find(p => p.attachment && (p.fileName.indexOf('.sig') == -1 || p.fileName.indexOf('.p7s') == -1))
    },
    attachedContentPart () {
      return this.docResponse.docResponseParts.filter(p => p.attachment && (p.fileName.indexOf('.sig') == -1 || p.fileName.indexOf('.p7s') == -1))
    }
  },

  methods: {
    selectToVerify(file) {
      this.showSelect = false
      this.$emit('verify', {sigId:this.selectedSig, partId:file.id, partName:file.origFileName})
    },
    selectToVerifyResponse(part) {
      this.selectedSig = part.id
      this.showSelect = true
    },
    verifyResponse(part) {
      this.$emit('verify', {sigId:part.id, partId:this.contentPart.id, partName:this.contentPart.origFileName})
    },

    viewResponse (part, enc) {
      if(enc)
          this.$emit('view', {partId:part.id, partName:part.origFileName.replace('.enc', '')})
      else 
          this.openWord(part);
    },

    openWord (part) {
      if(part.fileName==".docx"){
        let link="ms-word:ofv|u|"+document.location.origin+"/"+config.apiPath+"/file/response/part/"+part.id+"/"+part.origFileName
        window.open(link, '_self')
      } else
        this.openFile(part)
    },

    openFile (part) {
      let link=config.apiUrl+"file/response/part/"+part.id+"/"+part.origFileName
      window.open(link, '_self')
    },

    canSimpleView(part) {
      if( part.attachment && (part.fileName.indexOf('.enc') == -1) && (part.fileName.indexOf('.sig') == -1) && (part.fileName.indexOf('.p7s') == -1) && (part.fileName.indexOf('.p7m') == -1) ) return true
      return false
    },

    canEncView(part) {
      if( part.attachment && (part.fileName.indexOf('.enc') != -1)  ) return true
      return false
    },

    canSmimeEncView(part) {
      if( this.docResponse.docResponseParts.length<=2 && part.attachment && (part.fileName.indexOf('.p7m') != -1)  ) return true
      return false
    },

    canViewSig(part) {
      if( part.attachment && (part.fileName.indexOf('.sig') != -1 || part.fileName.indexOf('.p7s') != -1) && this.contentPart !== undefined) return true
      return false
    }
  },
  mounted() {
      let resp  = this.docResponse.docResponseParts.find(p => p.origFileName == "message.html")
      if (!resp) {
          resp  = this.docResponse.docResponseParts.find(p => p.origFileName == "message.txt")
          this.html = false
      }
      
      if (resp) {
          docService.readResponsePart(resp.id).then((data) => { 
              this.text = data 
          } )
      } 
  }

}
</script>